import type { AssistantChatMessageGenqlSelection } from '@rematter/frontend-lib-api-client';

export const assistantChatMessageFragment = {
  __typename: true,
  id: true,
  chatId: true,
  role: true,
  parts: {
    __typename: true,
    id: true,
    type: true,
    sequence: true,
    // Text & Reasoning parts
    text: true,
    state: true,
    // Tool call parts (ToolCall and DynamicTool)
    toolCallId: true,
    toolName: true,
    toolCallState: true,
    input: true,
    output: true,
    errorText: true,
    providerExecuted: true,
    // Source parts (SourceUrl and SourceDocument)
    sourceId: true,
    url: true,
    title: true,
    // File parts
    mediaType: true,
    filename: true,
    // Data parts
    dataType: true,
    data: true,
    // Provider metadata (available for most part types)
    providerMetadata: true,
  },
  agentId: true,
  createdAt: true,
} as const satisfies AssistantChatMessageGenqlSelection;
